import React, { Component, Fragment } from 'react';
import { Player, ControlBar, PlaybackRateMenuButton, ForwardControl } from 'video-react';
import "../../../node_modules/video-react/dist/video-react.css";
import CloseIcon from '@mui/icons-material/Close';


class ShowVideoEx extends Component {

    render () {  
        
        //let url = "https://webextank-api.webquake.com/api/Recording/"
        let url = "https://" + window.apiurl + "/api/Recording/"
        let token = "/?t=" + encodeURIComponent(this.props.token)
        let source = url + this.props.videoid + token;
        
        return (
            <Fragment>
               <div className="closeright"><span onClick={()=>this.props.closeVideoPageex()}>Aufzeichnung schliessen</span> <CloseIcon onClick={()=>this.props.closeVideoPage()} /></div>
               <Player autoPlay>
                <source src={source} />
              
                <ControlBar>
                    <PlaybackRateMenuButton rates={[5, 2, 1, 0.5, 0.1]} />
                    <ForwardControl seconds={5} order={3.1} />
                    <ForwardControl seconds={10} order={3.2} />
                    <ForwardControl seconds={30} order={3.3} />
                </ControlBar>
            </Player>
            </Fragment>
        )
    }
}


export default ShowVideoEx;